<template>
  <main class="w-screen max-h-screen">
    <ClipSpinner
      v-if="contentLoading"
      color="#93c5fd"
      size="50px"
      class="loader"
    />
    <div v-else>
      <ARScene
        v-if="!isVideo"
        :type="type"
        :isRelicsSave="false"
        :item="item"
        :name="name"
        :locale="locale"
        :isAudio="isAudio"
        :audio="audio"
        :isMusic="isMusic"
      />
      <VideoPlayer
        v-else
        :type="type"
        :isRelicsSave="false"
        :withModel="withModel"
        :video="video"
        :isAudio="isAudio"
        :audio="audio"
        :item="item"        
        @showARScene="isVideo = $event"
      />      
    </div>
  </main>
</template>
<script>
import service from "../../../services";
import ARScene from "../../../components/ARScene.vue";
import ClipSpinner from "vue-spinner/src/ClipLoader.vue";
import VideoPlayer from "@/components/VideoPlayer.vue";

export default {
  components: {
    ARScene,
    ClipSpinner,
    VideoPlayer
  },
  data() {
    return {
      type: "album",
      item: {},
      name: {
        ko: "",
        child: "",
        en: "",
        zh: "",
        ja: "",
      },
      locale: {
        ko: "",
        child: "",
        en: "",
        zh: "",
        ja: "",
      },
      video: {
        ko: "",
        child: "",
        en: "",
        zh: "",
        ja: "",
      },      
      audio: {
        ko: "",
        child: "",
        en: "",
        zh: "",
        ja: "",
      },
      isVideo: null,
      isAudio: true,
      isMusic: false,
      withModel: false,
      contentLoading: true,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      const parseString = require("xml2js").parseString;
      const id = this.$route.params.id;
      await service.relicFindOne(id).then(
        (response) => {
          const { data } = response;
          if (data.video.replace(/(<([^>]+)>)/gi, "")) {
            this.isVideo = true;
            this.$store.commit("saveIsVideo", true);
          } else {
            this.isVideo = false;
            this.$store.commit("saveIsVideo", false);
          }
          if (data.video.replace(/(<([^>]+)>)/gi, "") && data.model) {
            this.withModel = true;
          }
          if (data.audio.replace(/(<([^>]+)>)/gi, "")) {
            this.isAudio = true;
          } else {
            this.isAudio = false;
          }
          if (data.music) {
            this.isMusic = true;
          }
          if (data.name.replace(/(<([^>]+)>)/gi, "")) {
            parseString(data.name, (error, result) => {
              if (result.lang) {
                this.name.ko = result.lang.ko[0];
                this.name.child = result.lang.ko[0];
                this.name.en = result.lang.en[0];
                this.name.zh = result.lang.zh[0];
                this.name.ja = result.lang.ja[0];
                if (result.lang.ko[0] == "탈과 무언극의 연행") {
                  this.type = "webcam";
                  this.withModel = true;
                } else if (result.lang.ko[0] == "안내") {
                  this.type = "guide";
                }
              } else if (error) {
                console.log(error);
              }
            });
          }

          if (data.essential.replace(/(<([^>]+)>)/gi, "")) {
            parseString(data.essential, (error, result) => {
              if (result.lang) {
                this.locale.ko = result.lang.ko[0];
                this.locale.child = result.lang.child[0];
                this.locale.en = result.lang.en[0];
                this.locale.zh = result.lang.zh[0];
                this.locale.ja = result.lang.ja[0];
              } else if (error) {
                console.log(error);
              }
            });
          }
          if (data.video.replace(/(<([^>]+)>)/gi, "")) {
            parseString(data.video, (error, result) => {
              if (result.lang) {
                this.video.ko = result.lang.ko[0].split(",");
                this.video.child = result.lang.child[0].split(",");
                this.video.en = result.lang.en[0].split(",");
                this.video.zh = result.lang.zh[0].split(",");
                this.video.ja = result.lang.ja[0].split(",");
              } else if (error) {
                console.log(error);
              }
            });
          }
          if (data.audio.replace(/(<([^>]+)>)/gi, "")) {
            parseString(data.audio, (error, result) => {
              if (result.lang) {
                this.audio.ko = result.lang.ko[0];
                this.audio.child = result.lang.child[0];
                this.audio.en = result.lang.en[0];
                this.audio.zh = result.lang.zh[0];
                this.audio.ja = result.lang.ja[0];
              } else if (error) {
                console.log(error);
              }
            });
          }
          this.item = data;
          this.contentLoading = false;
        },
        (error) => {
          const { data } = error.response;
          this.contentLoading = false;
          console.log(data.message);
        }
      );
    },
  },
};
</script>

<style scoped>
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
